import { getField, updateField } from 'vuex-map-fields'
import api from '../api'
import router from '@/router'

export const state = {

	listLoading: false,
	buttonLoading: false,

	routerList: {},

	routerInfo: {
		sessions: [
			{ id: null }
		]
	},

	user: {
		name: '',
		email: '',
		password: '',
		weight: '',
		age: '',
		gender: ''
	},

	error: {
		email: '',
		password: '',
		name: '',
		weight: '',
		age: '',
		gender: ''
	},

	isConnecting: false,
	modalType: 'userType',
	device: {
		user: {},
		name: ''
	},

	timezone: '',

	clientList: [],

	createError: {},
	createForm: {
		id: '',
		name: '',
		macAddress: '',
		ipAddress: '',
		client: {
			id: '',
			name: '',
			email: '',
			host_email: '',
			company_name: ''
		},
		bands: [
			{
				name: '',
				macAddress: '',
				created_at: new Date()
			}
		],
	},

	activeTab: 0,
	registerTab: 0,

	scanning: false,

	bands: [],

	selected: [],

	deletedIds: []
}

export const mutations = {
	updateField,

	uploadProgress () {

	},

	clearCreateData (state) {
		state.createForm = {
			id: '',
			name: '',
			macAddress: '',
			client: {
				id: '',
				name: '',
                email: '',
                host_email: '',
                company_name: ''
			},
			bands: [{
				name: '',
				macAddress: '',
				created_at: new Date()
			}],
			ipAddress: ''
		}

		state.createError = {}
		state.activeTab = 0
		state.registerTab = 0
		state.scanning = false

		state.deletedIds = []
		state.selected = []
	}
}

export const actions = {

	async getRouterInfo ({ state }, payload) {
		state.listLoading = true

		const { data, status } = await api('get', '/cms/router/router-info?' + payload)

        if (status) {
            state.routerInfo = data.data
            state.listLoading = false
            return
        }

        state.routerInfo = {}
        state.listLoading = false
        return
	},

	async clearAll ({ state, dispatch }) {
		dispatch('clearForm')
		dispatch('clearError')
		state.isConnecting = false
		state.modalType = 'userType'
		state.device = ''
	},

	async clearForm ({ state }) {
		state.user = {
			name: '',
			email: '',
			password: '',
			weight: '',
			age: '',
			gender: ''
		}
	},

	async clearError ({ state }) {
		state.error = {
			email: '',
			password: '',
			name: '',
			weight: '',
			age: '',
			gender: ''
		}
	},

	async getRouterList ({ state }, payload) {
		state.listLoading = true

		const { data, status } = await api('get', `/cms/router/router-list${payload}`)

        if (status) {
            state.routerList = data.data
            state.listLoading = false
            return
        }

        state.routerList = {}
        state.listLoading = false
        return
	},

	async getBandList ({ state, }, payload) {
		state.listLoading = true

		const { data, status } = await api('get', '/cms/router/router-band?router_id=' + payload)
        
        if (status) state.bands = data.data.data

        state.listLoading = false
        return
	},

	async manageRouter ({ state, commit }, payload) {
		state.buttonLoading = true
		payload.commit = commit

		const { data, status } = await api('post', '/cms/router/manage-router', payload.form)

        if (status) {
            let message = 'Successfully registered a Router.'

            if (state.createForm.id) {
                message = 'Successfully updated a Router.'
            }

            payload.store.commit('modal/toggleNotification', {
                notificationName: 'notification-banner',
                notificationType: 'success',
                notificationDesc: message
            })
            const { band_list, id } = data.data
            state.createForm.id = id

            if (band_list.length) {
                state.createForm.bands = []
                band_list.forEach(band => {
                    state.createForm.bands.unshift({
                        id: band.id,
                        name: band.band_name,
                        macAddress: band.mac_address,
                        created_at: band.created_at,
                    })
                })
            } else {
                state.createForm.bands = []
                state.createForm.bands.unshift({
                    name: '',
                    macAddress: '',
                    created_at: new Date(),
                })
            }

            state.buttonLoading = false
            router.push({ name: 'router-list' })
            return
        }

        state.createError = data.errors
        state.buttonLoading = false
        return		
	},

	async getClientList ({ state }, payload) {
		state.buttonLoading = true

		const { data, status } = await api('get', `/cms/client/client-dropdown${payload}`)
        if (status) {
            state.clientList = data.data
            state.buttonLoading = false
            return
        }

        state.createError = data.error
        state.buttonLoading = false
        return
	},

	async deleteRouter ({ state, commit }, payload) {
		state.buttonLoading = true

		const { data, status } = await api('post', '/cms/router/delete-router', payload)

        if (status) {
            state.routerList = data.data
            state.selected = []

            commit('modal/toggleNotification', {
                notificationName: 'notification-banner',
                notificationType: 'success',
                notificationDesc: 'Successfully delete a router.',
            }, { root: true })

            state.buttonLoading = false
            return
        }

        state.buttonLoading = false
        return
	},

	async hasValues ({ state }) {
		const {
			id,
			name,
			macAddress,
			ipAddress,
			client,
			bands
		} = state.createForm

		return (name.trim() !== '' ||
				macAddress.trim() !== '' ||
				ipAddress.trim() !== '' ||
				client.id !== '' ||
				bands.some(band => band.name.trim() !== ''
					|| band.macAddress.trim() !== '')) && id === ''
		
	}
}

export const getters = {
	getField
}

export default {
	state,
	mutations,
	actions,
	getters,
	namespaced: true
}
